import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLogger } from '@mopla/logger';
import { ArrowTurnIcon, CreditCardIcon, MplButton } from '@mopla/ui';

import { PaymentErrorModal } from '../common';

interface IProps {
	onChangeMethodClick: VoidFunction;
	onRedirectToTrueLayer: VoidFunction;
	onCancel: VoidFunction;
}

export const ErrorStep: FC<IProps> = ({
	onChangeMethodClick,
	onRedirectToTrueLayer,
	onCancel,
}) => {
	const logger = useLogger('payment');
	const { t } = useTranslation('openBanking');

	useEffect(() => {
		logger.warn('TrueLayer: ErrorStep is mounted');
	}, [logger]);

	return (
		<PaymentErrorModal
			testId="ErrorStep"
			title={t('error')}
			onClose={onCancel}
			actions={
				<>
					<MplButton
						testId="ErrorStep-TryAgainButton"
						fullWidth
						endIcon={<ArrowTurnIcon />}
						onClick={onRedirectToTrueLayer}
					>
						{t('button.try_again')}
					</MplButton>
					<MplButton
						testId="ErrorStep-AnotherMethodButton"
						fullWidth
						startIcon={<CreditCardIcon />}
						onClick={() => onChangeMethodClick()}
					>
						{t('button.another_method')}
					</MplButton>
				</>
			}
		/>
	);
};
